import type { SkiAreaLifts } from '@/cms/fields/mappers/destinationPageFieldsMapper'
import { useIntl } from '@/intl'
import { Icon, type IconGlyph } from '@sunwebgroup/uds-ui/icon'
import { Typography } from '@sunwebgroup/uds-ui/typography'
import { InfoCard } from '../InfoCard/InfoCard'
import styles from './Lifts.module.css'

interface LiftsProps {
  data: SkiAreaLifts
}

export function Lifts({ data }: LiftsProps) {
  const intl = useIntl()
  const totalLifts = data.gondola + data.chair + data.surface

  const items = [
    { glyph: 'SkiLiftCabin', value: data.gondola, label: intl.formatMessage({ id: 'destination_ski_area_lifts_gondolas' }) },
    { glyph: 'SkiLiftChairSide', value: data.chair, label: intl.formatMessage({ id: 'destination_ski_area_lifts_chairlifts' }) },
    { glyph: 'SkiLiftDrag', value: data.surface, label: intl.formatMessage({ id: 'destination_ski_area_lifts_draglifts' }) },
  ]

  return (
    <InfoCard
      title={intl.formatMessage({ id: 'destination_ski_area_lifts_title' })}
      titleId="ski-area-lifts-title"
      tag={`${totalLifts} ${intl.formatMessage({ id: 'destination_ski_area_total' })}`}
    >
      <div className={styles.grid}>
        {items.map(({ glyph, value, label }) => (
          <div key={label} className={styles.liftItem}>
            <Icon glyph={glyph as IconGlyph} size={32} aria-hidden="true" />
            <Typography variant="display-j-regular">
              {value}
            </Typography>
            <Typography variant="body-s-regular-tight" className={styles.liftLabel}>
              {label}
            </Typography>
          </div>
        ))}
      </div>
    </InfoCard>
  )
}
